import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import { projectAuth } from "@/firebase/config";

Vue.use(Router);

const requireAuth = (to, from, next) => {
  let user = projectAuth.currentUser;
  if (!user) {
    next({ name: "Login" });
  }
  next();
};

const requireNoAuth = (to, from, next) => {
  let user = projectAuth.currentUser;
  if (user) {
    next({ name: "Dashboard" });
  }
  next();
};

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/legal",
      name: "PageLayout",
      redirect: "/privacy-policy",
      component: () => import("@/layout/PageLayout.vue"),
      children: [
        {
          path: "/terms-and-conditions",
          name: "TermsAndConditions",
          component: () => import("@/views/legal/TermsAndConditions.vue")
        },
        {
          path: "/privacy-policy",
          name: "PrivacyPolicy",
          component: () => import("@/views/legal/PrivacyPolicy.vue")
        }
      ]
    },
    {
      path: "/login",
      name: "AuthLayout",
      redirect: "/login",
      component: () => import("@/views/AuthLayout.vue"),
      beforeEnter: requireNoAuth,
      children: [
        {
          path: "/signup",
          name: "Signup",
          component: () => import("@/components/auth/Signup.vue")
        },
        {
          path: "/login",
          name: "Login",
          component: () => import("@/components/auth/Login.vue")
        },
        {
          path: "/forgot-password",
          name: "Forgot Password",
          component: () => import("@/components/auth/ForgotPassword.vue")
        }
      ]
    },
    {
      name: "Dashboard",
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/layout/DashboardLayout.vue"),
      beforeEnter: requireAuth,
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/views/Dashboard.vue")
        },
        {
          path: "/note/:id",
          name: "Note",
          component: () => import("@/views/Note.vue")
        },
        {
          path: "/settings",
          name: "Settings",
          component: () => import("@/views/Settings.vue")
        }
      ]
    }
  ]
});
